
/* slider auto height */
$(function(){
    var slide_item = $('.banner--slide');
    var maxHeight = 0;
    slide_item.each(function(){
       var slide_item_height = $(this).height();
       if (slide_item_height > maxHeight) { maxHeight = slide_item_height; }
    });
    $('.banner--slide').height(maxHeight);
});


/* CF7 Form redirect */
document.addEventListener( 'wpcf7mailsent', function( event ) {
    location = 'https://themidlandsnetwork.co.uk/thank-you/';
}, false );


$(function(){
    var formsection = $('.courseformsection');
    var formtoggle = formsection.find('.courseformsection__header');

    formtoggle.click(function(event){
        console.log('click');
        event.preventDefault();
        $(this).parents('.courseformsection').toggleClass('courseformsection--active');
        $(this).siblings().slideToggle();
        if($(this).attr('aria-expanded') === 'true'){
            $(this).attr('aria-expanded', 'false');
        }else{
            $(this).attr('aria-expanded', 'true');
        }
    });
});


// Course search drop down
$(function(){

    var toggle = $('.productsfilter__toggle');
    var content = $('.productsfilter__filter');

    toggle.click(function(event){
        event.preventDefault();
        console.log('click');

        $(this).toggleClass('productsfilter__toggle--active');
        content.slideToggle();

    });

});

//scrollto
$(function(){
    $(".footer__scroll").click(function() {
        console.log('click');
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
        return false;
    });
});

//footerlogo slider
$(function(){
    $(document).on('ready', function() {
        $(".footerlogos__slider").slick({
            dots: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: $('#logoslider__prev'),
            nextArrow: $('#logoslider__next'),
            autoplay: true,
            autoplaySpeed: 3000,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint:768,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint:992,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint:1200,
                    settings: {
                        slidesToShow: 8
                    }
                },
                {
                    breakpoint:1800,
                    settings: {
                        slidesToShow: 10
                    }
                },
            ]
        });
    });
});


/* company images count */
$(function(){

    var show_hide_nav = function(){
        console.log('function running');

        var browser_width = window.innerWidth;
        var break_point = 768;
        var company_images = $('.companyimages__imageitem');
        var count_array = [];
        var company_nav = $('.companyimages__nav');

        $(company_images).each(function(){
            var image_item = $(this);
            count_array.push(count_array);
        });

        var array_count = count_array.length;

        if(browser_width <= break_point && array_count >= 2){
            company_nav.show();
        }else if(browser_width >= break_point && array_count > 2){
            company_nav.show();
        }else if(browser_width >= break_point && array_count < 3){
            company_nav.hide();
        };
    };
    show_hide_nav();

    $(window).resize(function(){
        show_hide_nav();
    });
});


// list page float sidebar
// $(function(){
//
//     $(window).on('scroll', function(){
//
//         var browser_width = window.innerWidth;
//         var window_from_top = $(window).scrollTop(); //window from top
//
//         var sidebar = $('.postpage__sidebar');
//         var sidebar_width = $('.postpage__sidebar').width();
//         sidebar.css({"width" : sidebar_width})
//
//         var sidebar_wrap_top = $('.postpage__sidewrap').offset().top; // top of sidebar
//         var sidebar_wrap_height = $('.postpage__sidewrap').innerHeight(); //sidebarwrap height
//         var sidebar_wrap_bottom_from_top = sidebar_wrap_top + sidebar_wrap_height;
//
//         var sidebar_top = $('.postpage__sidebar').offset().top;
//         var sidebar_height = $('.postpage__sidebar').innerHeight(); // height of object
//         var sidebar_bottom_from_top = sidebar_top + sidebar_height;
//
//
//         if(window_from_top > sidebar_wrap_top && sidebar_bottom_from_top < sidebar_wrap_bottom_from_top){
//             console.log('---- top stick -----');
//             sidebar.addClass('postpage__sidebar--activetop');
//         }
//         else if(window_from_top < sidebar_wrap_top && sidebar_bottom_from_top < sidebar_wrap_bottom_from_top){
//             console.log('---- no top stick -----');
//             sidebar.removeClass('postpage__sidebar--activetop');
//             // sidebar.addClass('postpage__sidebar--activebottom');
//         }
//
//
//     });
//
// });



// function sticky_relocate() {
//     var window_top = $(window).scrollTop();
//     var footer_top = $("#footer").offset().top;
//     var div_top = $('#sticky-anchor').offset().top;
//     var div_height = $("#sticky").height();
//
//     var padding = 20;  // tweak here or get from margins etc
//
//     if (window_top + div_height > footer_top - padding)
//         $('#sticky').css({top: (window_top + div_height - footer_top + padding) * -1})
//     else if (window_top > div_top) {
//         $('#sticky').addClass('stick');
//         $('#sticky').css({top: 0})
//     } else {
//         $('#sticky').removeClass('stick');
//     }
// }
//
// $(function () {
//     $(window).scroll(sticky_relocate);
//     sticky_relocate();
// });
